import { render, staticRenderFns } from "./CustomerGrowth.vue?vue&type=template&id=80ac1c0e&"
import script from "./CustomerGrowth.vue?vue&type=script&lang=js&"
export * from "./CustomerGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports